var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-item',{attrs:{"item":{
      icon:'mdi-view-dashboard',
      title: 'Startseite',
      to: '/'
    }}}),_c('admin'),_vm._l((_vm.events),function(e){return [(e.type === 'stb_m_2021')?_c('stb-m2021',{key:e._id,attrs:{"name":e.name,"id":e._id}}):_vm._e(),(e.type === 'stb_w_2023')?_c('stb-w2023',{key:e._id,attrs:{"name":e.name,"id":e._id}}):_vm._e(),(e.type === 'stb_ltf_2024')?_c('stb-ltf2024',{key:e._id,attrs:{"name":e.name,"id":e._id}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }